import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import Navbar from './Navbar'
import Button from './ui/Button'
import AuthModal from './AuthModal'
import VerifyNumberModal from './VerifyNumberModal'

const AuthGuard = ({ children, requireAuth = true, title = "অ্যাক্সেস করতে লগিন প্রয়োজন", description = "এই পেজ দেখতে অ্যাকাউন্টে লগিন করুন।" }) => {
  const { user, logout, loading, refreshUser } = useAuth()
  const [isAuthOpen, setIsAuthOpen] = useState(false)
  const [authMode, setAuthMode] = useState('login')
  const [promptVerify, setPromptVerify] = useState(false)

  const openAuth = (mode = 'login') => {
    setAuthMode(mode)
    setIsAuthOpen(true)
  }

  // A registration that ends with an unverified number gets the verify-now
  // prompt as soon as the dialog closes. Login does not: the member has been
  // here before, and the profile banner already nags them.
  const handleAuthSuccess = (info) => {
    setIsAuthOpen(false)
    if (info?.mode === 'register' && info.user?.otp_verified !== true) setPromptVerify(true)
  }

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // Show login prompt if authentication is required but user is not authenticated
  if (requireAuth && !user) {
    return (
      <div className="min-h-screen bg-background">
        <Navbar user={user} onLogout={logout} onAuth={openAuth} />
        <div className="container mx-auto px-4 py-16 text-center">
          <h1 className="text-3xl font-bold text-foreground mb-4">{title}</h1>
          <p className="text-muted-foreground mb-8">{description}</p>
          <div className="space-x-4">
            <Button onClick={() => openAuth('login')}>
              লগিন করুন
            </Button>
            <Button variant="outline" onClick={() => openAuth('register')}>
              নতুন অ্যাকাউন্ট তৈরি করুন
            </Button>
          </div>
        </div>
        
        <AuthModal
          isOpen={isAuthOpen}
          onClose={() => setIsAuthOpen(false)}
          onSuccess={handleAuthSuccess}
          mode={authMode}
        />
      </div>
    )
  }

  // Render children with auth context
  return (
    <>
      {children({ user, logout, openAuth, isAuthenticated: !!user, refreshUser })}
      <VerifyNumberModal isOpen={promptVerify} onClose={() => setPromptVerify(false)} />
    </>
  )
}

export default AuthGuard